// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_m1-0";